export default __webpack_public_path__ + "static/media/btn_moodVeryGood.01545807.png";